import { StudioActionTypes } from './studio.types';

const studioAccountRequest = () => ({ type: StudioActionTypes.STUDIO_ACCOUNT_REQUEST });
const studioAccountSuccess = () => ({ type: StudioActionTypes.STUDIO_ACCOUNT_SUCCESS });
const studioAccountFailure = () => ({ type: StudioActionTypes.STUDIO_ACCOUNT_FAILURE });
const studioAccountSet = payload => ({ type: StudioActionTypes.STUDIO_ACCOUNT_SET, payload });

const studioFormCheckRequest = () => ({ type: StudioActionTypes.STUDIO_FORM_CHECK_REQUEST });
const studioFormCheckSuccess = () => ({ type: StudioActionTypes.STUDIO_FORM_CHECK_SUCCESS });
const studioFormCheckFailure = () => ({ type: StudioActionTypes.STUDIO_FORM_CHECK_FAILURE });
const studioFormCheckSet = payload => ({ type: StudioActionTypes.STUDIO_FORM_CHECK_SET, payload });

const studioFormSendRequest = payload => ({ type: StudioActionTypes.STUDIO_FORM_SEND_REQUEST, payload });
const studioFormSendSuccess = () => ({ type: StudioActionTypes.STUDIO_FORM_SEND_SUCCESS });
const studioFormSendFailure = () => ({ type: StudioActionTypes.STUDIO_FORM_SEND_FAILURE });
const studioFormSendSet = payload => ({ type: StudioActionTypes.STUDIO_FORM_SEND_SET, payload });

const studioTemplatesRequest = templatesDesired => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_REQUEST, payload: templatesDesired });
const studioTemplatesSuccess = () => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_SUCCESS });
const studioTemplatesFailure = () => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_FAILURE });
const studioTemplatesSet = payload => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_SET, payload });
const studioTemplatesLoading = payload => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_LOADING, payload });

const studioLogoBuilderAvailabilityRequest = () => ({ type: StudioActionTypes.STUDIO_LOGO_BUILDER_AVAILABILITY_REQUEST });
const studioLogoBuilderAvailabilitySuccess = () => ({ type: StudioActionTypes.STUDIO_LOGO_BUILDER_AVAILABILITY_SUCCESS });
const studioLogoBuilderAvailabilityFailure = () => ({ type: StudioActionTypes.STUDIO_LOGO_BUILDER_AVAILABILITY_FAILURE });
const studioLogoBuilderAvailabilitySet = payload => ({ type: StudioActionTypes.STUDIO_LOGO_BUILDER_AVAILABILITY_SET, payload });

const studioLogoGenerationRequest = payload => ({ type: StudioActionTypes.STUDIO_LOGO_GENERATION_REQUEST, payload });
const studioLogoGenerationSuccess = () => ({ type: StudioActionTypes.STUDIO_LOGO_GENERATION_SUCCESS });
const studioLogoGenerationFailure = () => ({ type: StudioActionTypes.STUDIO_LOGO_GENERATION_FAILURE });
const studioLogoGenerationSet = payload => ({ type: StudioActionTypes.STUDIO_LOGO_GENERATION_SET, payload });
const studioLogoGenerationLoading = payload => ({ type: StudioActionTypes.STUDIO_LOGO_GENERATION_LOADING, payload });
const studioLogoGenerationResetStatus = () => ({ type: StudioActionTypes.STUDIO_LOGO_GENERATION_RESET_STATUS });

const studioLogoDownloadRequest = payload => ({ type: StudioActionTypes.STUDIO_LOGO_DOWNLOAD_REQUEST, payload });
const studioLogoDownloadSuccess = payload => ({ type: StudioActionTypes.STUDIO_LOGO_DOWNLOAD_SUCCESS, payload });
const studioLogoDownloadFailure = payload => ({ type: StudioActionTypes.STUDIO_LOGO_DOWNLOAD_FAILURE, payload });

const studioProductsRequest = () => ({ type: StudioActionTypes.STUDIO_PRODUCTS_REQUEST });
const studioProductsSuccess = () => ({ type: StudioActionTypes.STUDIO_PRODUCTS_SUCCESS });
const studioProductsFailure = () => ({ type: StudioActionTypes.STUDIO_PRODUCTS_FAILURE });
const studioProductsSet = payload => ({ type: StudioActionTypes.STUDIO_PRODUCTS_SET, payload });
const studioProductsLoading = payload => ({ type: StudioActionTypes.STUDIO_PRODUCTS_LOADING, payload });

const studioRequestProvisionFreePlan = ({ onSuccessCallback } = { onSuccessCallback: null }) => ({ type: StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN, payload: { onSuccessCallback } });
const studioProvisionFreePlanSuccess = () => ({ type: StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_SUCCESS });
const studioProvisionFreePlanFailure = () => ({ type: StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_FAILURE });
const studioProvisionFreePlanLoading = payload => ({ type: StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_LOADING, payload });

const studioDocumentCreationRequest = payload => ({ type: StudioActionTypes.STUDIO_DOCUMENT_CREATION_REQUEST, payload });
const studioDocumentCreationSuccess = () => ({ type: StudioActionTypes.STUDIO_DOCUMENT_CREATION_SUCCESS });
const studioDocumentCreationFailure = () => ({ type: StudioActionTypes.STUDIO_DOCUMENT_CREATION_FAILURE });
const studioDocumentCreationLoading = payload => ({ type: StudioActionTypes.STUDIO_DOCUMENT_CREATION_LOADING, payload });

const logoBuilderClickedOnMenu = () => ({ type: StudioActionTypes.STUDIO_LOGO_BUILDER_CLICKED_ON_MENU });

const loading = payload => ({ type: StudioActionTypes.STUDIO_LOADING, payload });

const actions = {
  account: {
    request: studioAccountRequest,
    success: studioAccountSuccess,
    failure: studioAccountFailure,
    set: studioAccountSet,
  },
  formCheck: {
    request: studioFormCheckRequest,
    success: studioFormCheckSuccess,
    failure: studioFormCheckFailure,
    set: studioFormCheckSet,
  },
  formSend: {
    request: studioFormSendRequest,
    success: studioFormSendSuccess,
    failure: studioFormSendFailure,
    set: studioFormSendSet,
  },
  templates: {
    request: studioTemplatesRequest,
    success: studioTemplatesSuccess,
    failure: studioTemplatesFailure,
    set: studioTemplatesSet,
    loading: studioTemplatesLoading,
  },
  availability: {
    request: studioLogoBuilderAvailabilityRequest,
    success: studioLogoBuilderAvailabilitySuccess,
    failure: studioLogoBuilderAvailabilityFailure,
    set: studioLogoBuilderAvailabilitySet,
  },
  logoGeneration: {
    request: studioLogoGenerationRequest,
    success: studioLogoGenerationSuccess,
    failure: studioLogoGenerationFailure,
    set: studioLogoGenerationSet,
    loading: studioLogoGenerationLoading,
    resetStatus: studioLogoGenerationResetStatus,
  },
  logoDownload: {
    request: studioLogoDownloadRequest,
    success: studioLogoDownloadSuccess,
    failure: studioLogoDownloadFailure,
  },
  products: {
    request: studioProductsRequest,
    success: studioProductsSuccess,
    failure: studioProductsFailure,
    set: studioProductsSet,
    loading: studioProductsLoading,
  },
  provisionFree: {
    request: studioRequestProvisionFreePlan,
    success: studioProvisionFreePlanSuccess,
    failure: studioProvisionFreePlanFailure,
    loading: studioProvisionFreePlanLoading,
  },
  documentCreation: {
    request: studioDocumentCreationRequest,
    success: studioDocumentCreationSuccess,
    failure: studioDocumentCreationFailure,
    loading: studioDocumentCreationLoading,
  },
  clickedOnMenu: logoBuilderClickedOnMenu,
  loading,
};

export default actions;
